import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds, WireTransferCategory } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface ConfirmWireReceiptArg {
    engagementId: number;
    category: WireTransferCategory;
    sourceRowId: number | null;
    confirmed: boolean;
}

export const ConfirmWireReceipt = createAsyncThunk(
    'flowOfFunds/confirmWireReceipt',
    async (arg: ConfirmWireReceiptArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/ConfirmReceipt`,
                {
                    category: arg.category,
                    sourceRowId: arg.sourceRowId,
                    confirmed: arg.confirmed,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to confirm the wire was received');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while confirming the wire was received.',
                'error'
            );
            throw error;
        }
    }
);
